import React, { useState } from 'react'
import moment from 'moment';
import { useStyle } from "./Style";
import Grid from "@material-ui/core/Grid";
import { TextValidator, ValidatorForm } from 'react-material-ui-form-validator';

const FuneralClaimDetails = (props) => {
  const classes = useStyle();
 
  const [dateOfDeath, setDateOfDeath] = useState('')
  const [funeralHome, setFuneralHome] = useState('');
  const [deathCertficateNumber, setDeathCertificateNumber] = useState('')

  React.useEffect(() => {
    props.setAdditionalState("policy_start_date", props.eventData.start_date)
  }, [props.member.date_of_birth]);

  const handleChange = (event) => {
    const { name, value } = event.target;
    if (name === "cause_of_death") {
      handleSubmit(value)
    }

  }


  const handleSubmit = (value) => {

    const tempClaimInitiation = props.claimInitiationPayload;
    tempClaimInitiation["additional_details"] = {
      "age": getAge(),
    };
    props.setClaimInitiationPayload(tempClaimInitiation);
  }

  const getAge = () => {
    const dob = props.member.date_of_birth
    const dateOfDeath = props.eventDate
    const ageAtDeath = moment(dateOfDeath).diff(moment(dob), 'years');
    return ageAtDeath;
  };


  return (
    <>
      <Grid container spacing={2}>
        <Grid item xs={12} sm={12} md={12}>
          <div className={classes.headingclaim}>
            <h4>Deceased  details </h4>
          </div>
        </Grid>
      </Grid>
      <ValidatorForm onSubmit={() => { }}>
        <Grid container spacing={2} className={classes.selectpolicyWrapper}>
          <Grid item xs={12} md={4} sm={4}>
            <TextValidator
              id="name"
              style={{ width: "100%" }}
              label="first_name"
              name='first_name'
              value={props.member.first_name}
              variant="outlined"
            />
          </Grid>

          <Grid item xs={12} md={4} sm={4}>
            <TextValidator
              id="middle_name"
              style={{ width: "100%" }}
              label="middle_name"
              name='middle_name'
              value={props.member.middle_name}
              variant="outlined"
            />
          </Grid>

          <Grid item xs={12} md={4} sm={4}>
            <TextValidator
              id="last_name"
              style={{ width: "100%" }}
              label="last_name"
              name='last_name'
              value={props.member.last_name}
              variant="outlined"
            />
          </Grid>

          <Grid item xs={12} md={4} sm={4}>
            <TextValidator
              id="relationship"
              style={{ width: "100%" }}
              label="relationship"
              name='relationship'
              value={props.member.relationship}
              onChange={handleChange}
              variant="outlined"
            />
          </Grid>

          <Grid item xs={12} md={4} sm={4}>
            <TextValidator
              id="gender"
              style={{ width: "100%" }}
              label="gender"
              name='gender'
              value={props.member.gender}
              variant="outlined"
            />
          </Grid>



          <Grid item xs={12} md={4} sm={4}>
            <TextValidator
              id="date_of_birth"
              style={{ width: "100%" }}
              label="date_of_birth"
              name='date_of_birth'
              value={props.member.date_of_birth}
              variant="outlined"
            />
          </Grid>



          <Grid item xs={12} md={4} sm={4}>
            <TextValidator
              id="age"
              style={{ width: "100%" }}
              label="age"
              name='age'
              value={getAge()}
              variant="outlined"
            />
          </Grid>

          <Grid item xs={12} md={4} sm={4}>
            <TextValidator
              id="date_of_death"
              style={{ width: "100%" }}
              label="date_of_death"
              name='date_of_death'
              value={props.eventDate}
              variant="outlined"
            />
          </Grid>

        </Grid>

        <hr />

        <Grid container spacing={2} className={classes.selectpolicyWrapper}>

          <Grid item xs={12} sm={4} md={4}>
            <TextValidator
              id="dateOfDeath"
              label="Date Of Death"
              name='dateOfDeath'
              value={dateOfDeath}
              onChange={(e) => {
                setDateOfDeath(e.target.value)
                props.setAdditionalState("date_of_death", e.target.value)
              }}
              style={{ width: "100%" }}
              fullWidth
              type='date'
              InputLabelProps={{
                shrink: true,
              }}
              variant="outlined"
            />
          </Grid>

          <Grid item xs={12} sm={4} md={4}>
            <TextValidator
              id="funeralHome"
              label="Funeral Home Name"
              name='funeralHome'
              value={funeralHome}
              onChange={(e) => {
                setFuneralHome(e.target.value)
                props.setAdditionalState("funeral_home_name", e.target.value)
              }}
              style={{ width: "100%" }}
              variant="outlined"
            />
          </Grid>
          <Grid item xs={12} sm={4} md={4}>
            <TextValidator
              id="deathCertficateNumber"
              label="Death Certficate Number  "
              name='deathCertficateNumber'
              value={deathCertficateNumber}
              onChange={(e) => {
                setDeathCertificateNumber(e.target.value)
                props.setAdditionalState("death_certficate_number", e.target.value)
              }}
              style={{ width: "100%" }}
              variant="outlined"
            />

          </Grid>


        </Grid>

      </ValidatorForm>
    </>
  )
}

export default FuneralClaimDetails

